var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{attrs:{"color":"#2e70b6","dark":"","elevation":"0","app":"","fixed":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.handleDrawerToggle.apply(null, arguments)}}}),_c('v-toolbar-title',{staticClass:"app-title"},[_vm._v(" Central de Serviços ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }